"use strict";
var VIEW_MODES = require('./viewModes.js');
module.exports = {
    VIEW_MODES: VIEW_MODES
};
